import i18next from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import xhr from 'i18next-xhr-backend';
import languageDetector from 'i18next-browser-languagedetector';

import { languages, nameSpaces } from './constants';

i18next
  .use(xhr)
  .use(languageDetector)
  .use(reactI18nextModule)
  .init({
    whitelist: [...languages],
    fallbackLng: {
      'en-US': ['en'],
      default: ['en'],
    },
    ns: nameSpaces,
    defaultNS: nameSpaces[0],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      defaultTransParent: 'div',
      wait: true,
    },
  });

export default i18next;
